var config = require('./store-locator-config').directions;
var templates = require('./store-locator-templates');

// Global variables
//  - Updated from state on INIT
var map, mapView, directionsResultsDisplayer, directionsMarkers, originDestinationInput;

module.exports.init = function (state, dataSource) {

    map = state.map;
    mapView = state.mapView;
    tableview = state.tableview;

     // Init Geoloc
    directionsMarkers = [];
    var navigatorGeolocation = new woosmap.location.LocationProvider();
    var travelModeSelector = new woosmap.ui.TravelModeSelector(templates.travelModeSelector);
    originDestinationInput = new woosmap.ui.OriginDestinationInput(templates.directionsOriginDestination, {
      'geolocText': ''+Messages("woosmap.store.myposition")+''
    });
    state.originDestinationInput = originDestinationInput;

    var directionsProvider = new woosmap.location.DirectionsProvider(config.directionRendererOptions, config.googleDirectionsRequestOptions);
    // var mailView = new woosmap.ui.MailView(templates.directionsMailInput);
    var locationProvider = new woosmap.location.LocationProvider();
    var locationProviderMap = new woosmap.location.LocationProvider();

    var store_id = '';

    // User Geoloc
    //Increase accuracy of the localisation by using the standard geolocation functionality of the web browsers. Access this information by creating a MVCObject
    var directionsRestorer = new woosmap.utils.MVCObject();

    //Define a method that will automatically be called if the location is updated
    directionsRestorer.location = null;

    directionsResultsDisplayer = new woosmap.ui.DirectionsResultsDisplayer(
        map,
        templates.directionsSummary,
        functionDirectionsResultsDisplayer
    );

    // originDestinationInput.bindTo('selectedStore', mapView);
    directionsProvider.bindTo('selectedTravelMode', travelModeSelector);
    directionsProvider.bindTo('originDestination', originDestinationInput);
    directionsResultsDisplayer.bindTo('directionsSummaries', directionsProvider);
    directionsResultsDisplayer.bindTo('directionsRenderers', directionsProvider);
    directionsResultsDisplayer.bindTo('directionsLink', directionsProvider);
    originDestinationInput.bindTo('location', navigatorGeolocation);

    //bind it to the Location provider
    directionsRestorer.bindTo('location', locationProvider);

    woosmap.$('#my-direction').append(originDestinationInput.getODContainer());
    woosmap.$('#routes').append(directionsResultsDisplayer.getRoutesContainer());
    woosmap.$('#instructions-steps').append(directionsResultsDisplayer.getStepsContainer());
    woosmap.$('#directions-travel-mode-selector').append(travelModeSelector.getSelectorContainer());

    woosmap.$(".woosmap-directions-origin .woosmap-close-icon").click(function() {
      woosmap.$("#woosmap-directions-origin-input").val('');
    });

    woosmap.$(".woosmap-directions-destination .woosmap-close-icon").click(function() {
      woosmap.$("#woosmap-directions-destination-input").val('');
    });

    woosmap.$('#directions-travel-mode-selector .woosmap-travel-mode-option').click(function() {
      woosmap.$('#directions-travel-mode-selector .woosmap-travel-mode-option').removeClass('selected');
      woosmap.$(this).addClass('selected');
    });

    woosmap.$('.geolocation-button').click(function() {
      navigatorGeolocation.askForLocation(navigator.geolocation);
    });

    var storesInformationTemplateRenderer = new woosmap.TemplateRenderer(
      templates.closestStore
    );
    var storeSelectorId = '';
    var storesInformationDisplayer = new woosmap.utils.MVCObject();
    storesInformationDisplayer.stores = null;
    storesInformationDisplayer.stores_changed = function(data) {

    if (!this.get('stores')) return;
    var properties = this.get('stores')[0].properties;
    storeSelectorId = properties.store_id;

    if(storeSelectorId){
      $.ajax({
          "url": '/'+config.language+'/ajax/rest/model/atg/userprofiling/ProfileActor/setNavigationLocationId?navigationLocationId='+storeSelectorId,
          "data": {},
      })
    }

    mapView.set('selectedStore', this.get('stores')[0]);

    properties.distance = Math.round(properties.distance / 1000);
    woosmap
        .$('#store-info')
        .html(storesInformationTemplateRenderer.render(properties));
    };
    storesInformationDisplayer.bindTo('stores', mapView);
    var nearbyStoresSource = new woosmap.location.NearbyStoresSource(
      dataSource,
      10
    );
    nearbyStoresSource.bindTo('stores', mapView);

    if (!mapView.get('location'))
    mapView.bindTo('location', locationProviderMap);

    mapView.marker.setOptions({
      draggable: true
    });

    if (!nearbyStoresSource.get('location'))
    nearbyStoresSource.bindTo('location', locationProviderMap);

    woosmap.$("#html5-geolocation-button").click(function (data) {
      locationProviderMap.askForLocation(navigator.geolocation);
    });

    $('body').on('click', '.woosmap-travel-close', function(data,mapView,tableview,state) {
      cleanMarker();
      closeRouteContainer();
      displayRouteContainer(this);
      directionsResultsDisplayer.cleanRoutes();
      directionsResultsDisplayer.cleanRouteSteps();
      directionsResultsDisplayer.cleanMapFromRoutes();
    });



};

/**
 * HELPERS FUNCTIONS
 */

function closeRouteContainer() {
    woosmap.$('.woosmap-route-details').show();
  }

  function displayRouteContainer(container) {
    var $container = woosmap.$(container);
    $container.find('.route-summary-lower-panel').show();
    $container.find('.woosmap-route-details').show();
  }

  function makeMarker(position, icon, title) {
    directionsMarkers.push(new google.maps.Marker({
      position: position,
      map: map,
      icon: icon,
      title: title
    }));
  }

  function cleanMarker() {
    woosmap.$.each(directionsMarkers, function(index, marker) {
      marker.setMap(null);
    });
    directionsMarkers = [];
  }


  function functionDirectionsResultsDisplayer() {
    //this function is called when directionResultsDisplayer finished to display renderers
    directionsResultsDisplayer.displayRouteOnMap(0);
    directionsResultsDisplayer.displayRouteSteps(0);
    woosmap.$("#directions").show();
    var computedDirections = directionsResultsDisplayer.get("directionsRenderers")[0].getDirections();
    var leg = computedDirections.routes[0].legs[0];
    cleanMarker();
    makeMarker(leg.start_location, config.icons.start, "Start");
    makeMarker(leg.end_location, config.icons.end, 'End');

    closeRouteContainer();
    displayRouteContainer(woosmap.$('.woosmap-route-container')[0]);
    woosmap.$('.woosmap-route-container').first().addClass('selected');


    woosmap.$('.woosmap-route-container').click(function() {
      closeRouteContainer();
      displayRouteContainer(this);
      directionsResultsDisplayer.cleanMapFromRoutes();
      directionsResultsDisplayer.cleanRouteSteps();
      directionsResultsDisplayer.displayRouteOnMap(woosmap.$(this).find('.woosmap-show-steps').data('renderer-index'));
      directionsResultsDisplayer.displayRouteSteps(woosmap.$(this).find('.woosmap-show-steps').data('renderer-index'));
      var $this = woosmap.$(this);
      if (!$this.hasClass('selected')) {
        woosmap.$('.woosmap-route-container').removeClass('selected');
        $this.addClass('selected');
      } else {
        woosmap.$('#instructions').show();
        woosmap.$('#routes').hide();
        woosmap.$('#inputs').hide();
        woosmap.$('#instructions-mail').hide();
        woosmap.$('#directions').css('top', '5px');
        woosmap.$('#directions').css('bottom', '5px');
      }

    });


    woosmap.$('.woosmap-route-details').click(function() {
      woosmap.$('#instructions').show();
      woosmap.$('#routes').hide();
      woosmap.$('#inputs').hide();
      woosmap.$('#instructions-mail').hide();
      woosmap.$('#directions').css('top', '5px');
      woosmap.$('#directions').css('bottom', '5px');
    });

    woosmap.$('#close-instructions-button').click(function() {
      woosmap.$('#instructions').hide();
      woosmap.$('#routes').show();
      woosmap.$('#inputs').show();
      woosmap.$('#instructions-mail').show();
      woosmap.$('#directions').css('top', '135px');
      woosmap.$('#directions').css('bottom', '');
    });

  }



// WEBPACK FOOTER //
// ./src/modules-es5/pages/store-locator/store-locator-directions.js